import { useEffect, useRef, useState } from "react";

export const AnimatedAccordionContent = ({
    children,
    isOpen,
  }: {
    children: React.ReactNode;
    isOpen: boolean;
  }) => {
    const contentRef = useRef<HTMLDivElement>(null);
    const [height, setHeight] = useState<number>(0);
  
    useEffect(() => {
      const contentEl = contentRef.current;
      if (!contentEl) return;
  
      // Function to update height
      const updateHeight = () => {
        setHeight(isOpen ? contentEl.scrollHeight : 0);
      };
  
      // Initial update
      updateHeight();
  
      // Observe size changes
      const resizeObserver = new window.ResizeObserver(updateHeight);
      resizeObserver.observe(contentEl);
  
      return () => {
        resizeObserver.disconnect();
      };
    }, [isOpen, children]);
  
    return (
      <div
        className="overflow-hidden transition-all duration-300 ease-in-out border-t BookEZ_card_border_color"
        style={{
          height: isOpen ? `${height}px` : "0px",
          opacity: isOpen ? 1 : 0,
          transition:
            "height 50ms cubic-bezier(0.4, 0, 0.2, 1), opacity 70ms linear",
        }}
      >
        <div ref={contentRef} className="w-full">
          {children}
        </div>
      </div>
    );
  };